import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useMotion } from '@vueuse/motion';
import { useModule } from 'src/modules/modules';
import * as GameTypes from 'types/game.types';
import { getColorWithSimilarityInRange } from 'util/color-util';
import { wrapAround } from 'util/util';
import chroma from 'chroma-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'color-phasing-element',
  props: {
    is: null,
    targetColor: null,
    steps: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    is?: string,
    /**
     * The target color, which is only used to ensure that any step w/ the color set to 'random'
     * will be a color that is sufficiently different from the target color.
     */
    targetColor: chroma.Color,
    /**
     * The color phase steps
     */
    steps: GameTypes.PhaseStep[]
}

const { theme } = useModule();


const active = ref(true);
const stepIndex = ref(-1);
const stopPhase = ref<Function>();
const bgStartColor = theme.gameBg;
const bg = ref();

/**
 * This method parses the next step in the provided "steps" array and decides what the next color should be
 * and the duration of the transition to that color (if not explicitly provided).
 */
const step = async (fromColor: string) => {
    if (active.value === false) return;

    let currentStepIndex = wrapAround(stepIndex.value + 1, 0, props.steps.length - 1);
    let currentStep = props.steps[currentStepIndex];
    let duration = currentStep.duration === 'random' ? Phaser.Math.Between(1000, 4000) : currentStep.duration;
    let toColor = typeof currentStep.color === 'function' ? currentStep.color() : currentStep.color;
        toColor = toColor === 'random' ? getColorWithSimilarityInRange(props.targetColor, 85, 100).hex() : toColor;
        
    stepIndex.value = currentStepIndex;
    phaseToColor(fromColor, toColor, duration);
}

/**
 * Phases the background from one color to another and triggers the next step when it is complete.
 * 
 * @param fromColor 
 * @param toColor 
 * @param duration 
 */
const phaseToColor = (fromColor: string, toColor: string, duration: number) => {
    const { stop } = useMotion(bg, {
        initial: { background: fromColor },
        enter: {
            background: toColor,
            transition: {
                duration: duration,
                ease: 'linear',
                onComplete: () => step(toColor)
            }
        }
    })

    stopPhase.value = stop;
}

step('#00000000')

expose({
    stop: () => {
        active.value = false;
        stopPhase.value?.();
        let bgColor : string = bg.value?.style.background;
        if (bgColor) return chroma(bgColor);
        else return chroma('#000000');
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.is ?? 'div'), _mergeProps({
    ref_key: "bg",
    ref: bg
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})